export const GET_COUNTRIES = 'covid_data/countries/GET_COUNTRIES';

const getCountriesAction = (payload) => ({ type: GET_COUNTRIES, payload });

export default getCountriesAction;
